import BaseAPI from "../api";

const path = "customer-corporation";

export default class CustomerCorporationApi extends BaseAPI {
  static register(props: any): Promise<any> {
    return this.api.post(`${path}/register`, props).then((res) => res);
  }
  static update(props: any, id: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, props).then((res) => res);
  }
  static delete(id: any): Promise<any> {
    return this.api.delete(`${path}/file/${id}`).then((res) => res);
  }
  static file(id: any): Promise<any> {
    return this.api
      .get(`${path}/register/${id}`, { responseType: "arraybuffer" })
      .then((res) => res);
  }
  static register_file(customerId: any, props: any): Promise<any> {
    return this.api
      .post(`${path}/register/${customerId}/file`, props, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => res);
  }
}
